import { HTTP_CP_LoadSignUpBranding_Response } from '@api-new/companyservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';

export const getSignUpBranding = createAction('[SIGN UP] Get Branding');
export const getSignUpBrandingSuccess = createAction(
  '[SIGN UP] Get Branding Success',
  props<{
    branding: HTTP_CP_LoadSignUpBranding_Response;
  }>(),
);
export const getSignUpBrandingFailure = createAction('[SIGN UP] Get Branding Failure', props<{ error: ErrorModel }>());

export const setSignUpBrandingReferralCode = createAction('[SIGN UP] Set Branding Referral Code', props<{ referralCode: string }>());
